import type { ConfigEnv } from './types';

class Config {

  SENTRY_URL: string = '';
  OSS_BUCKET: string = '';
  OSS_ENDPOINT: string = '';
  BACKEND_HOST: string = '';
  BACKEND_MAIN_HOST: string = '';
  AG_GRID_LICENSE_KEY: string = '';
  IGNORE_AUTH_API: string[] = [];
  BACKEND_XUNDIAN_HOST: string[] = [];

  init(config: ConfigEnv): void {
    Object.assign(this, config);
  }

}

export const config = new Config();
export const CONFIG = config;
